/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const openPositionSearchFilterSchema = z.object({
  activeOnly: z.boolean(),
  filledStatus: z.enum(['OPEN', 'HIRED', 'ALL']),
  locationIds: z.array(z.int()).nullish(),
  loopIds: z.array(z.int()).nullish(),
  query: z.string(),
  roleIds: z.array(z.int()).nullish(),
  skillIds: z.array(z.int()).nullish(),
  teamIds: z.array(z.int()).nullish(),
});
